import React from 'react';
import { isMobile } from 'react-device-detect';
import Quote from './Quote';
import HomePage from './components/HomePage';
//import AboutPage from './components/AboutPage';
//import ContactPage from './components/ContactPage';
//import Navbar from "./components/Navbar";
//import ServicesPage from './components/Services';
//import HideAddressBar from './components/HideAddressBar';
import "./styles.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

//import AforismPage from './components/AforismPage';

function AppWrapper() {
  if (isMobile) {
    return (
      <Router>
        
       {/* <Navbar />*/}
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/*
          <Route path="/aforism" element={<AforismPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/services" element={<ServicesPage />} />
          */}
        </Routes>
       
            <Quote />

       
      </Router>
    );
  } else {
    return (
      <div class="mobile-msg">Questa app è disponibile solo per smartphones.</div>

    );
  }
}

export default AppWrapper;
